import Icon from '@/components/ui/AppIcon';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  color: string;
}

const StatCard = ({ title, value, icon, trend, color }: StatCardProps) => {
  return (
    <div data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:16:4" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="16" data-component-file="DelegationStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-surface%20border%20border-border%20rounded-lg%20p-6%22%7D" className="bg-surface border border-border rounded-lg p-6">
      <div data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:17:6" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="17" data-component-file="DelegationStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-4%22%7D" className="flex items-center justify-between mb-4">
        <div data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:18:8" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="18" data-component-file="DelegationStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`w-12 h-12 ${color} rounded-lg flex items-center justify-center`}>
          <Icon data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:19:10" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="19" data-component-file="DelegationStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={icon as any} size={24} className="text-white" />
        </div>
        {trend && (
          <div data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:22:10" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="22" data-component-file="DelegationStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex items-center gap-1 text-sm font-medium ${trend.isPositive ? 'text-success' : 'text-error'}`}>
            <Icon data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:23:12" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="23" data-component-file="DelegationStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={trend.isPositive ? 'ArrowTrendingUpIcon' : 'ArrowTrendingDownIcon'} size={16} />
            {trend.value}
          </div>
        )}
      </div>
      <h3 data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:28:6" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="28" data-component-file="DelegationStats.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-foreground%20mb-1%22%7D" className="text-2xl font-bold text-foreground mb-1">{value}</h3>
      <p data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:29:6" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="29" data-component-file="DelegationStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%7D" className="text-sm text-muted-foreground">{title}</p>
    </div>
  );
};

const DelegationStats = () => {
  const stats = [
    {
      title: 'Delegações Ativas',
      value: 24,
      icon: 'CheckBadgeIcon',
      color: 'bg-success',
      trend: { value: '+12%', isPositive: true },
    },
    {
      title: 'Aprovações Pendentes',
      value: 8,
      icon: 'ClockIcon',
      color: 'bg-warning',
      trend: { value: '-5%', isPositive: true },
    },
    {
      title: 'Expirando em 7 Dias',
      value: 5,
      icon: 'ExclamationTriangleIcon',
      color: 'bg-error',
      trend: { value: '+3', isPositive: false },
    },
    {
      title: 'Total Este Mês',
      value: 47,
      icon: 'ChartBarIcon',
      color: 'bg-accent',
      trend: { value: '+18%', isPositive: true },
    },
  ];

  return (
    <div data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:67:4" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="67" data-component-file="DelegationStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%20mb-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {stats.map((stat, index) => (
        <StatCard data-component-id="src/app/delegation-control-center/components/DelegationStats.tsx:69:8" data-component-path="src/app/delegation-control-center/components/DelegationStats.tsx" data-component-line="69" data-component-file="DelegationStats.tsx" data-component-name="StatCard" data-component-content="%7B%22elementName%22%3A%22StatCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" key={index} {...stat} />
      ))}
    </div>
  );
};

export default DelegationStats;